module.exports = [
    { value: 'League', label: 'League' },
    { value: 'Birthday Party', label: 'Birthday Party' },
    { value: 'Tournament', label: 'Tournament' },
    { value: 'Olympics', label: 'Olympics' },
    { value: 'Online', label: 'Online Meeting' },
    { value: 'Other', label: 'Other' },
]